import createAsyncSlice from '../utils/createAsyncSlice';

const historyOrders = createAsyncSlice({
  name: 'historyOrders',
  initialState: {
    data: [],
  },
});

export const fetchHistoryOrders = historyOrders.asyncAction;
export const { resetState: resetHistoryOrdersState } = historyOrders.actions;
export default historyOrders.reducer;
